import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Modal, Box } from "../../../components/ui";
import { campusApi } from "../campus-api";
import { Node, CreateNodeDto, UpdateNodeDto } from "../types";
import { modalStyle } from "../../../style/common";

interface NodeFormModalProps {
  open: boolean;
  onClose: () => void;
  node?: Node | null;
  campusId: number;
}

export default function NodeFormModal({ open, onClose, node, campusId }: NodeFormModalProps) {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (node) {
      setName(node.node_name);
    } else {
      setName("");
    }
  }, [node, open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name.trim()) {
      toast.warning("Please enter a node name");
      return;
    }

    setLoading(true);
    try {
      if (node) {
        const updateData: UpdateNodeDto = { name };
        await campusApi.updateNode(node.id, updateData);
        toast.success("Node updated successfully");
      } else {
        const createData: CreateNodeDto = { name, campusId };
        await campusApi.createNode(createData);
        toast.success("Node created successfully");
      }
      onClose();
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Failed to save node");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal onClose={onClose} open={open}>
      <Box sx={modalStyle}>
        <div className="p-6">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            {node ? "Edit Node" : "Add Node"}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Node Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-black dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter node name"
                required
              />
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Saving..." : node ? "Update" : "Create"}
              </button>
            </div>
          </form>
        </div>
      </Box>
    </Modal>
  );
}

